import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { assertNever } from '@which/shared'

import {
  useSubVerticalCampaignPetitionQuery,
  useSubVerticalCrScamsTopicPageQuery,
  useSubVerticalCrTopicPageQuery,
  useSubVerticalHubPageQuery,
  useSubVerticalNewsPageQuery,
  useSubVerticalPolicyAndInsightLandingQuery,
  useSubVerticalReviewsPageQuery,
} from '../../../generated/frontend'
import type { PageParams } from '../../../routes'
import { usePageProps } from '../../../shared/usePageProps'
import type { SubVerticalTemplateName } from '../sub-vertical-types'

export const useSubVerticalPageQuery = () => {
  const { subVerticalSlug, verticalSlug } = useParams<PageParams>()
  const { template, context } = usePageProps()
  const subVerticalTemplate = template as SubVerticalTemplateName

  const useQuery = useMemo(() => {
    switch (subVerticalTemplate) {
      case 'CR Topic':
        return useSubVerticalCrTopicPageQuery
      case 'CR Scams Topic':
        return useSubVerticalCrScamsTopicPageQuery
      case 'Subvertical':
        return useSubVerticalReviewsPageQuery
      case 'News Category Listing':
        return useSubVerticalNewsPageQuery
      case 'Hub Page':
        return useSubVerticalHubPageQuery
      case 'Campaigns Petition':
        return useSubVerticalCampaignPetitionQuery
      case 'Policy and Insight Landing Page':
        return useSubVerticalPolicyAndInsightLandingQuery
      default:
        assertNever(subVerticalTemplate)
    }
  }, [subVerticalTemplate])

  return useQuery({
    variables: {
      subVerticalSlug,
      context: context || '',
      pageNumber: 1,
      verticalSlug,
    },
  })
}
